if (!customElements.get('comparison-blocks')) {
  
  customElements.define(
    
    'comparison-blocks',
    
    class ComparisonBlocks extends HTMLElement {
      
      constructor() {
        super();
        this.swiperWrapper = this.querySelector('.swiper-wrapper');
        PCOtheme.Motion.inView(this, this.initSwiper.bind(this), { margin: '200px 0px 200px 0px' });
      }
      
      get getSlideItems() {
        return (this._cachedSlideItems = this._cachedSlideItems || Array.from(this.swiperWrapper.children));
      }
      
      initSwiper() {
        
        const slider = this.querySelector('.swiper');
        
        if (!slider) return;
        
        const swiper = new PCOtheme.Swiper.Swiper(slider, {
          modules: [
            PCOtheme.Swiper.Navigation
          ],
          navigation: {
            prevEl: '.comparison-blocks__arrow--prev',
            nextEl: '.comparison-blocks__arrow--next',
          },
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          loop: true,
          centeredSlides: true,
          grabCursor: true,
          speed: 500,
          spaceBetween: 0
        });
        
        // handle theme editor
        
        if (Shopify.designMode) {
          this.addEventListener('shopify:block:select', (event) => {
            swiper.slideTo(this.getSlideItems.indexOf(event.target));
          });
        }
      }
    }
  );
}